module.exports = __webpack_public_path__ + "static1710991110236-0.0.5.6/img/form_logo@2x.e4be054c.png";